
  import { SmartBannerConfig } from './index'
  export const config: SmartBannerConfig = {
    festivalName: 'POSITIV Festival 2025',
    appTitle: 'POSITIV Festival',
    appStoreId: '0',
    appleStoreUrl: 'https://apps.apple.com/fr/app/positiv-festival/id6484276465',
    googleStoreUrl: 'https://play.google.com/store/apps/details?id=to.chapi.positiv',
    appIconUrl: 'https://static.positiv.chapi.to/app-icon.jpeg',
  }
